const ThemeObj = {
  token: {
    colorPrimary: "#04286f",
    fontFamily: "Verdana, Geneva, Tahoma, sans-serif",
  },
};

export default ThemeObj;
